import { useFormik } from 'formik';
import LabelForms from '../forms/GenericBaseForms/LabelForms/LabelForms';
import TextInputComponent from '../forms/GenericBaseForms/TextInputComponent/TextInputComponent';
import * as Yup from 'yup';
import { ButtonComponent } from '../UI/ButtonComponent/ButtonComponent';
import './NewsLetterComponent.scss';
import { NewsLetterText } from './model';

const emailSchema = Yup.object().shape({
	email: Yup.string().email().min(2, 'Email is required').required()
});
const NewsLetterComponent = () => {
	const { errors, values, handleChange, handleSubmit } = useFormik({
		initialValues: {
			email: ''
		},
		onSubmit: values => {
			console.log('values submittitng', values);
		},
		validationSchema: emailSchema
	});
	return (
		<div className='newLetterComponent'>
			<div className='titleText'>
				<h3 className='heading'>{NewsLetterText.heading}</h3>
				<h5 className='content'>{NewsLetterText.content}</h5>
			</div>
			<div className='newsLetterForm'>
				<div className='newsLetterFormContainer'>
					<LabelForms text={`Email*`}></LabelForms>
					<TextInputComponent
						errorHelperText={<>{errors.email}</>}
						error={!!errors.email}
						placeholder=''
						name={'email'}
						value={values.email}
						onChange={handleChange}
					/>
				</div>

				<ButtonComponent
					text={NewsLetterText.submit}
					onClick={handleSubmit}
					style={'rounded-button secondary'}
				/>
			</div>
		</div>
	);
};

export default NewsLetterComponent;
